$(document).ready(function () {
  let subscriptionCreationTimes = Array.from(document.getElementsByClassName('subscription-date'));

  subscriptionCreationTimes.forEach(insertLaterTime);
})

function insertLaterTime(subscription, index,) {
  let laterTimeSpans = Array.from(document.getElementsByClassName('later-time'));
  laterTimeSpans[index].innerHTML = getLaterTime(subscription.innerHTML);
}

function getLaterTime(time) {
  let timeStamp = new Date(time);
  let tenMinutesLater = addMinutes(timeStamp, 10);
  let timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
  let timeString = tenMinutesLater.toLocaleString('fr', timeOptions);
  return timeString.replace(':', 'h');
}

function addMinutes(date, minutes) {
  return new Date(date.getTime() + minutes*60000);
}
